export default __webpack_public_path__ + "static/media/lebon.49fb6db0.png";